import type { DirectoryTownSummary } from '@/sanity/directory';

export const findTownForAreas = (
  towns: readonly DirectoryTownSummary[],
  areaSlugs: readonly (string | null | undefined)[],
): DirectoryTownSummary | null => {
  const publishedAreaSlugs = new Set(areaSlugs.filter(Boolean));

  return (
    towns.find((town) => publishedAreaSlugs.has(town.directoryAreaSlug)) ?? null
  );
};
